var map = {
	"./anmat.png": "44f4",
	"./centro-medico-talar.png": "b77c",
	"./cidi.png": "e8d3",
	"./cirujia-jf.png": "5123",
	"./clinica-lobos.png": "fb6f",
	"./corte-suprema.png": "6024",
	"./gba.png": "9c5a",
	"./gcba.png": "53bd",
	"./htal-priv-ntra-sra-de-la-merced.png": "403c",
	"./ministerio-de-salud.png": "5605",
	"./munic-escobar.png": "b02b",
	"./munic-exaltacion-de-la-cruz.png": "d14b",
	"./munic-malvinas.png": "09d5",
	"./munic-merlo.png": "0eb0",
	"./munic-san-isidro.png": "68e5",
	"./munic-san-miguel-soi.png": "42cc",
	"./occhiuzzi.png": "98e8",
	"./sanatorio-colegiales.png": "1244",
	"./sanatorio-guemes.png": "8ae3",
	"./servicio-penitenciario.png": "e412",
	"./swiss-medical.png": "4eeb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c795";